import { render, staticRenderFns } from "./WsRequestGroupField.vue?vue&type=template&id=2ce79f5b&scoped=true"
import script from "./WsRequestGroupField.vue?vue&type=script&lang=js"
export * from "./WsRequestGroupField.vue?vue&type=script&lang=js"
import style0 from "./WsRequestGroupField.vue?vue&type=style&index=0&id=2ce79f5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce79f5b",
  null
  
)

export default component.exports